import { PhaseEntityType, converToEntityId } from 'components/organisms/projects/project-plan/phase-entity';
export const migrations = {
    addEntityOrderToProjectTemplatePhases: (projectTemplate)=>{
        var _ref;
        var _projectTemplate_templateContent_projectPhases;
        if (!projectTemplate.templateContent.projectPhases || projectTemplate.templateContent.projectPhases.every((phase)=>phase.entityOrder !== undefined)) {
            return projectTemplate;
        }
        const migratedProjectTemplate = {
            ...projectTemplate,
            templateContent: {
                ...projectTemplate.templateContent,
                projectPhases: (_ref = (_projectTemplate_templateContent_projectPhases = projectTemplate.templateContent.projectPhases) === null || _projectTemplate_templateContent_projectPhases === void 0 ? void 0 : _projectTemplate_templateContent_projectPhases.map((phase)=>{
                    var _phase_entityOrder;
                    return {
                        ...phase,
                        entityOrder: (_phase_entityOrder = phase.entityOrder) !== null && _phase_entityOrder !== void 0 ? _phase_entityOrder : phase.tasks.filter((task)=>!task.isNew).map((task)=>converToEntityId(task.taskId, PhaseEntityType.Task))
                    };
                })) !== null && _ref !== void 0 ? _ref : []
            }
        };
        return migratedProjectTemplate;
    },
    removeNewDependenciesFromProjectTemplate: (projectTemplate)=>{
        var _ref;
        var _projectTemplate_templateContent_projectPhases;
        if (!projectTemplate.templateContent.projectPhases) {
            return projectTemplate;
        }
        const migratedProjectTemplate = {
            ...projectTemplate,
            templateContent: {
                ...projectTemplate.templateContent,
                projectPhases: (_ref = (_projectTemplate_templateContent_projectPhases = projectTemplate.templateContent.projectPhases) === null || _projectTemplate_templateContent_projectPhases === void 0 ? void 0 : _projectTemplate_templateContent_projectPhases.map((phase)=>({
                        ...phase,
                        tasks: phase.tasks.map((task)=>{
                            if (task.dependentTasks) {
                                task.dependentTasks = task.dependentTasks.filter((dependency)=>!dependency.dependencyType || // Include if dependencyType is not defined
                                    dependency.dependencyType === 'FINISH_TO_START');
                            }
                            return task;
                        })
                    }))) !== null && _ref !== void 0 ? _ref : []
            }
        };
        return migratedProjectTemplate;
    }
};
